import { render, staticRenderFns } from "./Chronik.vue?vue&type=template&id=34ef1db8"
import script from "./Chronik.vue?vue&type=script&lang=js"
export * from "./Chronik.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34ef1db8')) {
      api.createRecord('34ef1db8', component.options)
    } else {
      api.reload('34ef1db8', component.options)
    }
    module.hot.accept("./Chronik.vue?vue&type=template&id=34ef1db8", function () {
      api.rerender('34ef1db8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Chronik.vue"
export default component.exports